import { render, staticRenderFns } from "./RequirementGroupField.vue?vue&type=template&id=98772734"
import script from "./RequirementGroupField.vue?vue&type=script&lang=js"
export * from "./RequirementGroupField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports